import stepOne from "../../images/steps/step-1.png"
import stepTwo from "../../images/steps/step-2.png"
import stepThree from "../../images/steps/step-3.png"


function Hero() {
    const cards = [
        {
            "title": "Schedule",
            "subheader": "Schedule a pickup or drop-off in Bucks County and surrounding areas.",
            "image": stepOne
        },
        {
            "title": "Donate",
            "subheader": "Pack your usable books in a box and send them our way.",
            "image": stepTwo
        },
        {
            "title": "Prep & Share",
            "subheader": "Donated books are carefully prepared and placed where they’ll be appreciated most.",
            "image": stepThree
        }
    ]

    const renderProcessCard = (item) => {
        return (
            <div className="card">
                <div className="card-image">
                    <img src={item.image} alt="" />
                </div>
                <div className="card-content">
                    <h3>{item.title}</h3>
                    <p>{item.subheader}</p>
                </div>
            </div>
        )
    };

    return (
        <>
            <section className="process" id="process">
                <div className="process-title">
                    <h1>How it Works</h1>
                </div>
                <div className="process-cards">
                    {cards.map(renderProcessCard)}
                </div>
            </section>
        </>
    )
}

export default Hero;